import { IAuthActionTypes, IAuthActionCreator } from 'models/IAuthState';

const initialState: any = {
  userDeleted:false,
  userDeleteError:"",
  loading:false,
};

export const IDeleteAccountActionTypes = {
    USER_DELETE_REQUEST:"USER_DELETE/REQUEST",
    USER_DELETE_FAILURE:"USER_DELETE/FAILURE",
    USER_DELETE_SUCCESS:"USER_DELETE/SUCCESS",
}


const reducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case IDeleteAccountActionTypes.USER_DELETE_REQUEST:
        return {
          ...state,
          loading: true,
          userDeleteError:"",    
        }

    case IDeleteAccountActionTypes.USER_DELETE_FAILURE:
      return {
        ...state,
        userDeleteError: payload.error,    
      }
    case IDeleteAccountActionTypes.USER_DELETE_SUCCESS:
      return {
        ...state,
        userDeleted:true,
        userDeleteError:"",
        loading:false,
       
      }

    default:
      return state;
  }
};

export default reducer;
